import { render } from "./BookingSummary.vue?vue&type=template&id=6233a2a3"
import script from "./BookingSummary.vue?vue&type=script&lang=js"
export * from "./BookingSummary.vue?vue&type=script&lang=js"

import "./BookingSummary.vue?vue&type=style&index=0&id=6233a2a3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__